import CollaborationStore from '@/store/collaboration.store';
// import CloseIcon from '@/assets/common/ic_close_small.svg?react';
import { useMemo } from 'react';
import AIQA from '@/layout/AIQA';
import { ESidebarTab, SIDEBAR_TABS } from '@/pages/Collaboration/constant';
import AiIcon from '@/assets/summary/ai.svg?react';
import './index.less';
import ChapterSummary from './ChapterSummary';
import { RuningInLink } from '@/constants';
import { isWindows } from '@/utils/platform';

const CollaborationSidebar = () => {
  const sidebarActiveTab = CollaborationStore((state) => state.sidebarActiveTab);
  const setSidebarActiveTab = CollaborationStore((state) => state.setSidebarActiveTab);
  // const setShowbar = CollaborationStore((state) => state.setShowSidebar);

  const SidebarContent = useMemo(() => {
    switch (sidebarActiveTab) {
      case ESidebarTab.SUMMARY:
        return <ChapterSummary />;
      case ESidebarTab.AIQA:
        return <AIQA onlyContent />;
    }
  }, [sidebarActiveTab]);

  const SidebarTabs = useMemo(() => {
    const tabs = SIDEBAR_TABS.filter(tab => !tab.disabled);
    const sortedTabs = [...tabs].sort((a, b) => b.serial - a.serial);
    setSidebarActiveTab(sortedTabs[0].key);
    return tabs;
  }, [setSidebarActiveTab]);

  const handleTabClick = (tab: ESidebarTab) => {
    setSidebarActiveTab(tab);
  };
  // const handleClose = () => {
  //   setShowbar(false);
  // };
  return (
    <div
      className={`w-80 h-full ${RuningInLink && isWindows() ? 'mt-1' : ''
        } overflow-hidden flex-shrink-0 rounded-2.5 relative flex flex-col sidebar-container b-1 b-solid b-#fff`}
    >
      {/* <CloseIcon className="z-10 position-absolute top-5 right-3.5 size-6 cursor-pointer" onClick={handleClose} /> */}
      <div className="flex text-mx-secondary relative gap-9 items-center px-4 py-3.5 font-bold text-4.5">
        {SidebarTabs.map((tab) => (
          <div
            onClick={() => {
              handleTabClick(tab.key);
            }}
            key={tab.key}
            className={`text-4.5 lh-6.5 ml-0 relative cursor-pointer ${tab.key === sidebarActiveTab ? 'text-mx-secondary font-600' : 'text-mx-tertiary font-400'
              } `}
          >
            {tab.label}
            {sidebarActiveTab === tab.key && (
              <>
                <div className="position-absolute left-0 right-0 bottom--1.5 m-auto w-5 h-0.75 bg-gradient-to-r from-#5F84EF  to-#85ACFC  rounded-1"></div>
                <AiIcon className="absolute top--1 right--4 size-3.5" />
              </>
            )}
          </div>
        ))}
      </div>
      <div className="flex-1 flex flex-col overflow-hidden sidebar-content">{SidebarContent}</div>
    </div>
  );
};

export default CollaborationSidebar;
